import { Middleware } from "redux";
import { ApplicationState } from "../store/ApplicationState";

export const appConfigMiddleware: Middleware<{}, ApplicationState> = //eslint-disable-line
  () => (next) => (action: any) => {
    return next(action);
  };